<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <page-header title="Lista" subTitle="Gerentes" />

    <!-- Default Light Table -->
    <d-row>
      <d-col>
        <d-card class="card-small mb-4">
          <div
            class="card-header border-bottom d-md-flex justify-content-between"
          >
            <d-col
              sm="12"
              md="6"
              class="d-flex justify-content-center justify-content-md-start align-items-center"
            >
              <h6 class="m-0">Gerentes ativos</h6>
            </d-col>
            <d-col sm="12" md="6">
              <input-search
                :model.sync="pagination.search"
                id="input_distributor_list_search"
              />
            </d-col>
          </div>
          <div class="card-body p-0 pb-3 text-left">
            <div class="table-overflow">
              <manager-table :managers="managers.list" />
            </div>
            <pagination
              :total-items="managers.total_items"
              :pagination.sync="pagination"
              :eventName="'update:pagination_manager_list'"
            />
          </div>
        </d-card>
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';

import Events from '_utils/events';
import PageHeader from '_shared/PageHeader.vue';
import Pagination from '_shared/Pagination.vue';
import InputSearch from '_shared/InputSearch.vue';
import paginationStorageMixin from '_common/mixins/paginationStorageMixin';
import ManagerTable from '../components/ManagerListTable.vue';

export default {
  name: 'manager-list',
  components: {
    PageHeader,
    ManagerTable,
    Pagination,
    InputSearch,
  },
  mixins: [paginationStorageMixin],
  data() {
    return {
      pagination: {
        search: '',
        skip: (this.$route.params.page - 1) * 10,
        take: 10,
        page: parseInt(this.$route.params.page, Number),
      },
    };
  },
  computed: {
    managers() {
      const { managerList } = this.$store.state.manager;
      if (managerList && managerList.list.length) {
        return managerList;
      }
      return {
        list: [],
        total_items: 0,
      };
    },
  },
  methods: {
    ...mapActions(['checkAdmin', 'getManagerList']),
    getList() {
      this.getManagerList(this.pagination);
    },
  },
  mounted() {
    this.checkAdmin();
    Events.$emit('sidebarVisible', false);
    Events.$on('update:pagination_manager_list', pagination => {
      const paramsPage = parseInt(this.$route.params.page, 10);
      this.saveCurrentPage(this.pagination);
      if (paramsPage !== pagination.page) {
        this.$router.push({ params: { page: pagination.page } });
      }
      this.getList();
    });
  },
  destroyed() {
    Events.$off('update:pagination_manager_list');
  },
};
</script>
